export const DATABASE_NAME = "caloriegrid";

export const TABLE_NAME = "caloriegrid";
